import axios from 'axios'
import {
    PaymentMethodResponse
} from '@/modules/configurationModule/detail/accounting/billable/payment-method/services/payment-method.dto'

class BillingCommonPaymentMethodService {
    async getAllActivePaymentMethods(): Promise<PaymentMethodResponse[]> {
        const response =
            await axios.get<PaymentMethodResponse[]>(
                `/billing/paymentMethods`)
        return response.data
    }
}
export const billingCommonPaymentMethodService = new BillingCommonPaymentMethodService()
